import { useState } from "react";
import { put } from "../services/Services";

export const usePut = () => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const executePut = async (url, data, config = {}) => {
    setLoading(true);
    try {
      const response = await put(url, data, config);
      return response.data;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { executePut, error, loading };
};
